import React from 'react';
import { Typography } from '@mui/material';
import { Wrapper } from './PaymentMethod.styles';
import { neutrals } from 'utils/styles/color';
import { useWindowDimensions } from 'pages/AuthPage/AuthPage';
import { getPaymentIcon } from 'organisms/PaymentOptionCard/helpers';

type PaymentMethodProps = {
  method: PMethod;
  hideExpireDate?: boolean;
  isCryptoDisabled?: boolean;
};

const PaymentMethod = ({
  method,
  hideExpireDate,
  isCryptoDisabled,
}: PaymentMethodProps) => {
  const { width } = useWindowDimensions();
  const { name, last4, image, expire } = getPaymentIcon(method);
  const maskedLast4 = last4 ? <>&bull;&bull;&bull;&bull; {last4}</> : null;

  if (name === 'Crypto') {
    return (
      <Wrapper>
        {image}
        <div className="payment-option-info">
          <Typography
            variant="body1"
            fontSize="13px"
            fontWeight={400}
            color={neutrals[700]}
          >
            {name}
          </Typography>

          {isCryptoDisabled ? (
            <Typography
              fontSize="11px"
              lineHeight="16px"
              variant="body2"
              fontWeight={width < 600 ? 400 : 300}
              color={neutrals[700]}
            >
              (Coming soon)
            </Typography>
          ) : null}
        </div>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {image}
      <div className="payment-option-info">
        <Typography
          variant="body1"
          fontSize="13px"
          fontWeight={400}
          color={neutrals[700]}
        >
          {name} {expire ? maskedLast4 : ''}
        </Typography>
        {hideExpireDate || method.paymentMethod === 'crypto' ? null : (
          <>
            {expire ? (
              <Typography
                fontSize="11px"
                lineHeight="16px"
                variant="body2"
                fontWeight={width < 600 ? 400 : 300}
                color={neutrals[700]}
              >
                {expire}
              </Typography>
            ) : (
              <Typography
                variant="body2"
                lineHeight="16px"
                fontSize="11px"
                fontWeight={width < 600 ? 400 : 300}
                color={neutrals[700]}
              >
                {maskedLast4}
              </Typography>
            )}
          </>
        )}
      </div>
    </Wrapper>
  );
};

export default PaymentMethod;
